/* GENERAL */
export const GET_GENERAL = "GET_GENERAL"
export const GET_GENERAL_SUCCESS = "GET_GENERAL_SUCCESS"
export const GET_GENERAL_FAIL = "GET_GENERAL_FAIL"

export const GET_STATE = "GET_STATE"
export const GET_STATE_SUCCESS = "GET_STATE_SUCCESS"
export const GET_STATE_FAIL = "GET_STATE_FAIL"

export const GET_STATE_2 = "GET_STATE_2"
export const GET_STATE_2_SUCCESS = "GET_STATE_2_SUCCESS"
export const GET_STATE_2_FAIL = "GET_STATE_2_FAIL"

export const GET_GENERAL_SETTING = "GET_GENERAL_SETTING"
export const GET_GENERAL_SETTING_SUCCESS = "GET_GENERAL_SETTING_SUCCESS"
export const GET_GENERAL_SETTING_FAIL = "GET_GENERAL_SETTING_FAIL"

export const UPDATE_GENERAL_SETTING = "UPDATE_GENERAL_SETTING"
export const UPDATE_GENERAL_SETTING_SUCCESS = "UPDATE_GENERAL_SETTING_SUCCESS"
export const UPDATE_GENERAL_SETTING_FAIL = "UPDATE_GENERAL_SETTING_FAIL"

export const GET_GENERAL_USE = "GET_GENERAL_USE"
export const GET_GENERAL_USE_SUCCESS = "GET_GENERAL_USE_SUCCESS"
export const GET_GENERAL_USE_FAIL = "GET_GENERAL_USE_FAIL"

//payment method
export const GET_PAYMENT_METHOD = "GET_PAYMENT_METHOD"
export const GET_PAYMENT_METHOD_SUCCESS = "GET_PAYMENT_METHOD_SUCCESS"
export const GET_PAYMENT_METHOD_FAIL = "GET_PAYMENT_METHOD_FAIL"

export const GET_PAYMENT_METHOD_LIST = "GET_PAYMENT_METHOD_LIST"
export const GET_PAYMENT_METHOD_LIST_SUCCESS = "GET_PAYMENT_METHOD_LIST_SUCCESS"
export const GET_PAYMENT_METHOD_LIST_FAIL = "GET_PAYMENT_METHOD_LIST_FAIL"

export const ADD_NEW_PAYMENT_METHOD = "ADD_NEW_PAYMENT_METHOD"
export const ADD_PAYMENT_METHOD_SUCCESS = "ADD_PAYMENT_METHOD_SUCCESS"
export const ADD_PAYMENT_METHOD_FAIL = "ADD_PAYMENT_METHOD_FAIL"

export const EDIT_PAYMENT_METHOD = "EDIT_PAYMENT_METHOD"
export const EDIT_PAYMENT_METHOD_SUCCESS = "EDIT_PAYMENT_METHOD_SUCCESS"
export const EDIT_PAYMENT_METHOD_FAIL = "EDIT_PAYMENT_METHOD_FAIL"

export const DELETE_PAYMENT_METHOD = "DELETE_PAYMENT_METHOD"
export const DELETE_PAYMENT_METHOD_SUCCESS = "DELETE_PAYMENT_METHOD_SUCCESS"
export const DELETE_PAYMENT_METHOD_FAIL = "DELETE_PAYMENT_METHOD_FAIL"

//payment configuration
export const GET_PAYMENT_CONFIGURATION_DETAILS = "GET_PAYMENT_CONFIGURATION_DETAILS"
export const GET_PAYMENT_CONFIGURATION_DETAILS_SUCCESS = "GET_PAYMENT_CONFIGURATION_DETAILS_SUCCESS"
export const GET_PAYMENT_CONFIGURATION_DETAILS_FAIL = "GET_PAYMENT_CONFIGURATION_DETAILS_FAIL"

export const ADD_NEW_PAYMENT_CONFIGURATION = "ADD_NEW_PAYMENT_CONFIGURATION"
export const ADD_PAYMENT_CONFIGURATION_SUCCESS = "ADD_PAYMENT_CONFIGURATION_SUCCESS"
export const ADD_PAYMENT_CONFIGURATION_FAIL = "ADD_PAYMENT_CONFIGURATION_FAIL"

export const EDIT_PAYMENT_CONFIGURATION = "EDIT_PAYMENT_CONFIGURATION"
export const EDIT_PAYMENT_CONFIGURATION_SUCCESS = "EDIT_PAYMENT_CONFIGURATION_SUCCESS"
export const EDIT_PAYMENT_CONFIGURATION_FAIL = "EDIT_PAYMENT_CONFIGURATION_FAIL"

export const DELETE_PAYMENT_CONFIGURATION = "DELETE_PAYMENT_CONFIGURATION"
export const DELETE_PAYMENT_CONFIGURATION_SUCCESS = "DELETE_PAYMENT_CONFIGURATION_SUCCESS"
export const DELETE_PAYMENT_CONFIGURATION_FAIL = "DELETE_PAYMENT_CONFIGURATION_FAIL"

//payment dp
export const GET_PAYMENT_LIST = "GET_PAYMENT_LIST"
export const GET_PAYMENT_LIST_SUCCESS = "GET_PAYMENT_LIST_SUCCESS"
export const GET_PAYMENT_LIST_FAIL = "GET_PAYMENT_LIST_FAIL"

export const GET_PAYMENT_GATEWAY = "GET_PAYMENT_GATEWAY"
export const GET_PAYMENT_GATEWAY_SUCCESS = "GET_PAYMENT_GATEWAY_SUCCESS"
export const GET_PAYMENT_GATEWAY_FAIL = "GET_PAYMENT_GATEWAY_FAIL"

export const GET_PAYMENT_TYPE_DROPDOWN = "GET_PAYMENT_TYPE_DROPDOWN"
export const GET_PAYMENT_TYPE_DROPDOWN_SUCCESS = "GET_PAYMENT_TYPE_DROPDOWN_SUCCESS"
export const GET_PAYMENT_TYPE_DROPDOWN_FAIL = "GET_PAYMENT_TYPE_DROPDOWN_FAIL"

export const RESET_GENERAL_STATE = 'RESET_GENERAL_STATE';
